var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',{staticClass:"login-body mb-5"},[(_vm.currentMember)?_c('p',[_vm._v("Inloggad som "+_vm._s(_vm.currentMember.email))]):_vm._e(),_c('button',{staticClass:"btn btn-primary .signup-loggedin",attrs:{"type":"button"},on:{"click":_vm.joinEventClicked}},[_vm._v(" Anmäl dig ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }